import styled from "styled-components";

export const PrincipalDiv = styled.div`
  margin-bottom: 2%;
  background-color: #370459;
  color: white;
`;

export const BaseDiv = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 4% 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    padding: 4% 10px;
  }
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-wrap: wrap;

  h1 {
    font-size: 20px;
    margin-bottom: 10px;
    color: white;
  }
  p {
    font-size: 16px;
    margin: 5px 0;
    color: white;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 800px) {
    flex-direction: column;
    text-align: center;
    gap: 10px; /* Reduzir gap em mobile */
  }
`;

export const Logo = styled.img`
  height: 90px;
  width: auto;
  object-fit: contain;
  display: block;
  margin-right: 15px; /* Usar px em vez de % para evitar recalculos */
  margin-top: 10px;

  @media (max-width: 800px) {
    height: 80px;
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const AddressDiv = styled.div`
  padding: 10px;
  min-height: 100px;
  border-right: 1px solid white;

  @media (max-width: 800px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid white;
    padding: 5px; /* Reduzir padding */
  }
`;

export const ContactDiv = styled.div`
  padding: 10px;
  margin-left: 10px;

  @media (max-width: 800px) {
    text-align: center;
    width: 100%;
    margin-left: 0;
    padding: 5px; /* Reduzir padding */
  }
`;

export const IconsDiv = styled.div`
  padding: 2px;
  display: flex;
  gap: 10px;
  margin-top: 10px;

  .icons {
    width: 1.5em;
    height: 1.5em;
    cursor: pointer;

    @media (max-width: 800px) {
      width: 2.0em;
      height: 2.0em;
    }
  }
`;

export const ContentDivText = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

export const CopyRight = styled.div`
  text-align: center;
  margin-top: 2%;
  color: var(--purple-dark);
  font-weight: bold;
  background-color: white;

  p {
    margin: 5px 0;
    color: var(--purple-dark);
  }

  strong {
    color: var(--orange);
  }

  @media (max-width: 1450px) {
    margin: 2% 0;
  }
`;